exports.INVOICE_STATUS = {
    NEW: 'NEW',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    RESTORE_PENDING: 'RESTORE_PENDING',
    POSTING: 'POSTING',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    CONFIRMED: 'CONFIRMED',
    WAITING_TO_CONFIRM: 'WAITING_TO_CONFIRM',
    FAILURE: 'FAILURE',
    INVALID: 'INVALID',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING',
    DELETED: 'DELETED',
    REJECTED: 'REJECTED',
    PO: ['PENDING_APPROVAL', 'POSTING', 'WARNING', 'ERROR', 'FAILURE']
}


exports.INVOICE_FILE_TYPE = {
    IMAGE: 'IMAGE',
    DOCUMENT: 'DOCUMENT',
}


exports.EVENT_TYPES = {
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    APPROVE: 'APPROVE',
    // CLICK: 'CLICK',
    // VIEW: 'VIEW',
}